import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "overlay overlay-block" }
const _hoisted_2 = { class: "overlay-wrapper" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "overlay-layer bg-dark bg-opacity-5 d-flex flex-column"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Reload")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", { setIsIframeFullyLoaded: _ctx.setIsIframeFullyLoaded })
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isReady)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _hoisted_5,
          (_ctx.isTimeout)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_base_button, {
                  onClick: _ctx.reloadIframe,
                  size: "small",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}